import "@/styles/base.scss";
import React, { FC } from "react";
import {
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import Header from "@/features/Header/Header";
import { useAuthStore } from "@/store/auth";
import { Seo, SITE_NAME } from "@/components/Seo/Seo";
import { sanitizeNextPath } from "@/utils/authRedirect";
import cls from "./styles.module.scss";

interface AuthProps {
  ignoreAuth?: boolean;
}

const AUTH_PAGE_TITLES: Record<string, string> = {
  "/login": "Войти",
  "/register": "Создать аккаунт",
  "/reset-password": "Восстановить пароль",
  "/set-new-password": "Новый пароль",
  "/otp": "Подтверждение почты",
  "/logout": "Выход",
  "/change-password": "Сменить пароль",
};

export const Auth: FC<AuthProps> = ({ ignoreAuth = false }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const pageTitle = AUTH_PAGE_TITLES[pathname];

  if (!ignoreAuth && isAuthenticated) {
    return (
      <Navigate
        to={sanitizeNextPath(searchParams.get("next")) || "/"}
        replace
      />
    );
  }

  return (
    <div className={cls.wrapper}>
      {pageTitle && (
        <Seo
          title={`${pageTitle} — ${SITE_NAME}`}
          description={`${pageTitle} на сайте «${SITE_NAME}».`}
          canonicalPath={pathname}
          noindex
        />
      )}
      <Header />
      <div className={cls.container}>
        <Outlet />
      </div>
    </div>
  );
};
